import { useEffect } from 'react'
import { useAdminState } from '../context/AdminContext'
import type { ApiError } from './client'
import { isAccessLost } from './problems'

/**
 * Route a mid-session 403 from any /admin/* call to the Not-Authorized view
 * (rather than a silent broken screen). Screens pass their react-query error.
 */
export function useForbiddenGuard(error: unknown): void {
  const { notifyForbidden } = useAdminState()
  useEffect(() => {
    if (error && (error as ApiError).status === 403) {
      notifyForbidden()
    }
  }, [error, notifyForbidden])
}

/**
 * Write-side variant: only a 403 that means the caller lost platform-admin access goes
 * to the Not-Authorized view. Super-admin tier, D5 (self_deactivation, last_super_admin)
 * and CSRF refusals stay on the screen as inline messages.
 */
export function useWriteForbiddenGuard(error: unknown): void {
  const { notifyForbidden } = useAdminState()
  useEffect(() => {
    if (error && isAccessLost(error)) {
      notifyForbidden()
    }
  }, [error, notifyForbidden])
}
